import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

export function OpenTelemetryIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <use href="#app-icon-open-telemetry" />
    </Icon>
  );
}
